import React from 'react';

import { IonList } from '@ionic/react';

import Modal, {
  ModalApplyButton,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalRefreshButton,
  ModalTitle,
} from 'components/Modal';

import FiltersContext from './FiltersContext';
import './filters.css';
import { HierarchyContext, useHierarchy } from './hierarchy';
import { FiltersConfig, FiltersValues, useFilters } from './useFilters';

export interface FiltersProps {
  onSubmit: (values: FiltersValues) => void;
  onClose: any;
}

const Filters: React.FC<FiltersConfig & FiltersProps> = ({
  onSubmit,
  onClose,
  initialValues,
  defaultValues,
  children,
}) => {
  const { values, setFieldValue, resetFilters, canResetFilters } = useFilters({
    initialValues,
    defaultValues,
  });
  const { state, register, unregister } = useHierarchy({
    values: values,
  });

  return (
    <Modal onClose={onClose} onSubmit={() => onSubmit(values)}>
      <ModalContent>
        <FiltersContext.Provider value={{ values, setFieldValue }}>
          <HierarchyContext.Provider value={{ state, register, unregister }}>
            <IonList>{children}</IonList>
          </HierarchyContext.Provider>
        </FiltersContext.Provider>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton />
        <ModalTitle>Filters</ModalTitle>
        {canResetFilters ? <ModalRefreshButton onClick={resetFilters} /> : null}
        <ModalApplyButton />
      </ModalFooter>
    </Modal>
  );
};

export default Filters;
